// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCyr9ElXSuaL-7WfLOOkmXXtIJ7MxTnBL8",
  authDomain: "dh2642-ht25.firebaseapp.com",
  projectId: "dh2642-ht25",
  storageBucket: "dh2642-ht25.firebasestorage.app",
  messagingSenderId: "853817080630",
  appId: "1:853817080630:web:fb9c394acc4540a2b15197",
  measurementId: "G-T021877NQT"
};